import { render, staticRenderFns } from "./BorrowerDetail.vue?vue&type=template&id=0b73a31b&"
import script from "./BorrowerDetail.vue?vue&type=script&lang=js&"
export * from "./BorrowerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports